"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNegative = void 0;
const is_number_1 = require("./is-number");
exports.isNegative = (value) => is_number_1.isNumber(value) && value < 0;
//# sourceMappingURL=is-negative.js.map